import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const location = useLocation();
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const params = new URLSearchParams(location.hash.replace(/^#/, ""));
        const sessionId = params.get("session_id");
        if (!sessionId) {
            navigate("/login", { replace: true });
            return;
        }

        (async () => {
            try {
                await api.post("/auth/session", { session_id: sessionId });
                const me = await api.get("/auth/me");
                const user = me.data;
                // Populate the global auth state BEFORE navigating so ProtectedRoute
                // doesn't redirect to /login while waiting for /auth/me.
                setUser(user);
                // Route based on user state
                if (!user.plan) navigate("/pricing", { replace: true });
                else if (user.onboarding_step !== "done") navigate("/onboarding", { replace: true });
                else navigate("/dashboard", { replace: true });
            } catch (e) {
                console.error("auth callback failed", e);
                navigate("/login", { replace: true });
            }
        })();
    }, [location, navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
            <div className="font-mono text-sm text-secondary-c">Авторизація…</div>
        </div>
    );
}
